import React from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'

import { Icon } from 'components/_new/ui'

import s from './Star.scss'


type StarProps = {
  className?: string
  value: number
}


const Star: React.FunctionComponent<StarProps> = ({ className, value }) => {
  const isStrokeStarVisible = value !== 100
  const isFilledStarVisible = value > 0
  const fillContainerStyle = useMemo(() => ({ width: `${value}%` }), [ value ])

  return (
    <div className={cx(s.container, className)}>
      {
        isStrokeStarVisible && (
          <Icon
            className={s.star}
            name="star"
            color="gray-30"
            noWrapper
          />
        )
      }
      {
        isFilledStarVisible && (
          <div className={s.fillContainer} style={fillContainerStyle}>
            <Icon
              className={s.star}
              name="star"
              color="brand"
              noWrapper
            />
          </div>
        )
      }
    </div>
  )
}


export default Star
